import { FC } from 'react'
import ReactMarkdown from 'react-markdown'

// Wraps React Markdown's Markdown component to style certain rendered components,
// e.g. make hyperlinks blue, and enforce conventions, e.g. open them in a new tab
export const Markdown: FC<React.ComponentProps<typeof ReactMarkdown>> = (
  props,
) => {
  return (
    <ReactMarkdown
      components={{
        a: ({ node, ...props }) => (
          <a className="text-hyperlink-blue" target="_blank" {...props} />
        ),
        p: ({ node, ...props }) => (
          <p className="pt-6 first-of-type:pt-0" {...props} />
        ),
      }}
      {...props}
    />
  )
}
